import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/VIPA.png'


const _withScopeId = n => (_pushScopeId("data-v-b0563862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"margin-right":"2%"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This is a message", -1))
const _hoisted_5 = { class: "dialog-footer" }

import {ref} from "vue";
import store from './store'
import request from "@/api";
import {router} from "@/router";
import Cookies from 'js-cookie'
import {ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

function notImplemented(){
  ElMessage.error('Not implemented yet')
}


async function loginOut(){
  console.log("login out")
  // store.commit("loginOut")
  // Cookies.remove("userTicket")

  // router.push('/homepage')  //返回主页

      // , store.commit("getUserTicket")  //不需要加参数，header里面有
  await request.post("/user/logout").then(
      res => {
        console.log(res);
        //console.log(res.data.data.code);
        if (res.status === 200) {
          console.log("退出成功了");
        } else
          console.log("退出时出现了错误");
      }
  ).catch(err => {
    console.log(err);
    console.log("logout error");
  });

  store.commit("loginOut")
  localStorage.removeItem("userTicket")
  // location.reload()
  router.push('/homepage')



  // try
  // router.push('/')
  // router.go(0)



  // request.get("user/logout").then(
  //     res => {
  //       console.log(res);
  //       //console.log(res.data.data.code);
  //       if (res.status === 200) {
  //         console.log("退出成功了");
  //       } else
  //         console.log("退出时出现了错误");
  //     }
  // ).catch(err => {
  //   console.log(err);
  //   console.log("logout error");
  // });




  // location.reload()  //刷新当前页面
}
function login_init(){
  const _username = localStorage.getItem("username")
  const access = localStorage.getItem('access')
  console.log("localStorage", _username, access)
  console.log("userTicket: ", localStorage.getItem("userTicket"))
  if(_username!=null){
    console.log("setAccount", _username)
    store.commit("loginIn")
    store.commit("setAccount", _username)
    store.commit('setAccess', access)
  }
}
login_init()

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              mode: "horizontal",
              "background-color": "white",
              "text-color": "#4C4C4C",
              "active-text-color": "#7C391D",
              class: "el-menu-demo",
              ellipsis: false,
              router: "router"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_el_menu_item, { index: "homepage" }, {
                  default: _withCtx(() => [
                    _createTextVNode("HOME")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "Tutorial" }, {
                  default: _withCtx(() => [
                    _createTextVNode("TUTORIAL")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "pruning" }, {
                  default: _withCtx(() => [
                    _createTextVNode("PRUNING")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "benchmark" }, {
                  default: _withCtx(() => [
                    _createTextVNode("BENCHMARK")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "history" }, {
                  default: _withCtx(() => [
                    _createTextVNode("TASK")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "submission" }, {
                  default: _withCtx(() => [
                    _createTextVNode("SUBMISSION")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "voc" }, {
                  default: _withCtx(() => [
                    _createTextVNode("SUB-HISTORY")
                  ]),
                  _: 1
                }),
                (_unref(store).state.isAut && _unref(store).state.access===0)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: "cub",
                      style: {"color":"#AB140C"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("APPROVAL")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_3,
                (!_unref(store).state.isAut)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      class: "right",
                      index: "signin"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("log in / register")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_sub_menu, {
                      key: 2,
                      class: "right"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(store).state.username), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: "user",
                          style: {"font-size":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("your profile")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "",
                          onClick: loginOut,
                          style: {"font-size":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("sign out")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Tips",
      width: "30%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}
}

})